module.exports = __webpack_public_path__ + "img/fotogalerie.bf16f051.svg";